export default __webpack_public_path__ + "static/media/know-about.c035dafc.webp";